module.exports = __webpack_public_path__ + "img/icon-chart-pie.9328ba90.svg";